import { useOutletContext } from "react-router-dom";

/**
 * The shared gradebook, for any page under `/gradebooks/:gradebookId`.
 *
 * `GradebookLayout` fetches the book once and stays mounted for as long as the
 * URL is inside that section, so the sheet, the Assessments page and Insights
 * all read the SAME object. Before that, the three were sibling routes each
 * calling `useGradebook` for themselves, and hopping between them re-downloaded
 * the roster, every column, the categories and every mark in the book.
 *
 * Returns `{ gradebook, refetch, mutate }`, and **`gradebook` is never null** —
 * the layout has already handled loading and failure, so a child renders only
 * once there is something to render. That is why the pages no longer each carry
 * a spinner and a not-found branch.
 *
 * Lives in its own file purely because the layout may export only components:
 * `react-refresh/only-export-components` disables fast refresh for a module that
 * mixes the two, and the sheet is exactly the kind of stateful page where losing
 * hot reload hurts most.
 */
export function useGradebookData() {
  return useOutletContext();
}
